export default function (themes) {
  const defaultMenuClass = themes[0].class; // default menu class to show if no theme is found
  // Find the li.group element of the nav that contains the theme name to add the theme class and hide the group element. By default, the subpages are hidden and the default menu gets the class for the main theme.
  function hideNavigationGroup() {
    const group = $('#mainNavigation .group');
    group.each(function () {
      const groupItem = $(this);
      const theme = themes.find((theme) =>
        groupItem.children().first().text().includes(theme.name),
      );
      if (theme) {
        groupItem.addClass(theme.class + '-menu').hide();
        // move the groupItem to the start of the list to remains the styles for the last item dropdown
        groupItem.insertBefore(groupItem.parent().children().first());
      } else {
        groupItem.addClass(defaultMenuClass);
      }
    });
  }

  // create the menu structure

  // secondLevel replace the class 'subitems' with 'items' to create the inner dropdown
  function createSecondLevel($group) {
    const $secondLevelList = $group.children();
    if ($secondLevelList.length > 2) {
      $secondLevelList.each(function () {
        const $item = $(this);
        // if item has class 'subitem' remove it
        if ($item.hasClass('subitems')) {
          $item.removeClass('subitems');
          $item.addClass('items');
        }
      });
    }
  }

  // firstLevel replace the class 'items' with 'groups' to create the outer dropdown
  function createFirstLevel($menu) {
    $menu.removeClass('items').addClass('groups');
    const $firstLevelList = $menu.children();
    $firstLevelList.first().remove();

    $firstLevelList.each(function () {
      const $group = $(this);
      $group.removeClass('item').addClass('group');
      if ($group.children().length > 2) {
        createSecondLevel($group);
      }
    });
  }
  // Create the menu structure
  function createMenu($menu) {
    const $groups = $($menu).find('.items');
    const $mainNavigationUL = $('#mainNavigation ul.groups');
    // append the new menu structure to the main navigation
    $mainNavigationUL.last().after($groups);
    // remove the default menu structure
    $mainNavigationUL.first().remove();
    // create the new menu structure
    createFirstLevel($groups);
  }

  // update home link based on theme
  function updateHomeLink(theme) {
    $('.header-logo, .footer-logo').each(function () {
      $(this).attr('href', theme.homeLink);
    });
  }

  // checks if the body has class from the themes array and applies the theme navigation structure
  function applyThemeNavigation() {
    const activeTheme = themes.find((theme) => $('body').hasClass(theme.class));

    if (activeTheme) {
      const $activeMenu = $(`.${activeTheme.class}-menu`);
      $(`.${defaultMenuClass}`).remove();
      createMenu($activeMenu);
      updateHomeLink(activeTheme);
    }
  }

  hideNavigationGroup();
  applyThemeNavigation();
}
